module.exports = __webpack_public_path__ + "media/images/flags/1x1/dnk-939119922be4d90b1cbb5f979069bd9b.svg";